<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- Merchant -->
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="merchantId"
                    item-text="merchantName"
                    dense
                    return-object
                    clearable
                    @change="getChart();
                    loading = true;"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>

            <v-col md="12" class="pa-2">
                <chart
                    v-if="chartData"
                    ref="chart"
                    :chartData="chartData"
                ></chart>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import Chart from '@/components/reports/charts/RevenueSource.vue';

export default {
    components: {
        'chart': Chart,
    },
    beforeMount() {
        this.getMerchants();
    },
    data() {
        return {
            chartData: null,
            merchants: null,
            merchant: {},
        }
    },
    methods: {
        getMerchants() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-crm-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `get-crm-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getChart() {
            axios({
            method: 'post',
            url: `revenue-source`,
            data: { merchant: this.merchant },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.chartData = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>